(function () {
  function init(sectionEl) {
    const nameEl = sectionEl.querySelector('[data-co-selected-name]');
    let imgEl = sectionEl.querySelector('[data-co-image]');
    const placeholder = sectionEl.querySelector('[data-co-image-placeholder]');
    const swatches = Array.from(sectionEl.querySelectorAll('[data-co-color-name]'));

    if (!swatches.length || !nameEl) return;

    function setSelected(btn, { focus = false } = {}) {
      const nextName = btn.getAttribute('data-co-color-name') || '';
      const nextUrl = btn.getAttribute('data-co-image-url') || '';

      swatches.forEach((b) => {
        const selected = b === btn;
        b.classList.toggle('is-selected', selected);
        b.setAttribute('aria-checked', selected ? 'true' : 'false');
        b.tabIndex = selected ? 0 : -1;
      });

      nameEl.textContent = nextName;

      if (!nextUrl) return;

      if (placeholder) placeholder.style.display = 'none';

      if (!imgEl) {
        const media = sectionEl.querySelector('.color-options__media');
        if (!media) return;

        const img = document.createElement('img');
        img.setAttribute('data-co-image', '');
        img.loading = 'lazy';
        img.style.width = '100%';
        img.style.height = 'auto';
        media.appendChild(img);

        imgEl = img; // ✅ важно
      }

      imgEl.alt = nextName;
      if (imgEl.getAttribute('src') !== nextUrl) imgEl.src = nextUrl;

      if (focus) btn.focus();
    }

    swatches.forEach((btn) => {
      btn.addEventListener('click', () => setSelected(btn));
    });

    sectionEl.addEventListener('keydown', (e) => {
      const active = document.activeElement;
      if (!active || !active.matches('[data-co-color-name]')) return;

      const currentIndex = swatches.indexOf(active);
      if (currentIndex < 0) return;

      let nextIndex = currentIndex;

      switch (e.key) {
        case 'ArrowRight':
        case 'ArrowDown':
          nextIndex = (currentIndex + 1) % swatches.length;
          e.preventDefault();
          break;
        case 'ArrowLeft':
        case 'ArrowUp':
          nextIndex = (currentIndex - 1 + swatches.length) % swatches.length;
          e.preventDefault();
          break;
        case 'Home':
          nextIndex = 0;
          e.preventDefault();
          break;
        case 'End':
          nextIndex = swatches.length - 1;
          e.preventDefault();
          break;
        case 'Enter':
        case ' ':
          setSelected(active);
          e.preventDefault();
          return;
        default:
          return;
      }

      setSelected(swatches[nextIndex], { focus: true });
    });

    const initial =
      swatches.find((b) => b.getAttribute('aria-checked') === 'true') || swatches[0];
    setSelected(initial);
  }

  function initAll() {
    document.querySelectorAll('section.co').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (e) => {
    const sectionEl = e.target && e.target.querySelector('section.co');
    if (sectionEl) init(sectionEl);
  });
})();